export default __webpack_public_path__ + "static/media/BANK_OEFFNUNGSZEITEN_DE_MANUAL.df74ce2d.png";